import { AxiosRequestConfig, AxiosResponse } from 'axios';
import createHttp from '@/utils/axiosHttp';
import NProgress from 'nprogress';
import { useAccountStore } from './index';
import { message } from 'ant-design-vue';

const http = createHttp({
  timeout: 15000,
  baseURL: '/mall',
});

// 兜底：把当前 token 同步到 axios defaults.headers.common，
// 这样 axios 在每个请求里自动带 Authorization，不再依赖请求拦截器
const initToken = window.localStorage.getItem('access_token');
if (initToken) {
  http.defaults.headers.common['Authorization'] = initToken;
}

const isAxiosResponse = (obj: any): obj is AxiosResponse => {
  return typeof obj === 'object' && obj.status && obj.statusText && obj.headers && obj.config;
};

// progress 进度条 -- 开启
http.interceptors.request.use((req: AxiosRequestConfig) => {
  req.headers['Authorization'] = window.localStorage.getItem('access_token') || '';
  if (!NProgress.isStarted()) {
    NProgress.start();
  }
  return req;
});

const handleUnauthorized = (tip?: string) => {
  if ((window as any).__unauthorizedHandling) return;
  (window as any).__unauthorizedHandling = true;
  message.error(tip || '登录已过期，请重新登录');
  useAccountStore()
    .logout()
    .finally(() => {
      setTimeout(() => {
        (window as any).__unauthorizedHandling = false;
        window.location.href = '/login';
      }, 100);
    });
};

// 解析响应结果
http.interceptors.response.use(
  (rep: AxiosResponse<String>) => {
    // progress 进度条 -- 关闭
    if (NProgress.isStarted()) {
      NProgress.done();
    }
    const { data }: any = rep;
    if (data.code === 1) {
      return data;
    } else {
      if (data.code === 9 || data.code === 401 || /未登录|登录已过期|token\s*失效/i.test(data.tip || '')) {
        handleUnauthorized(data.tip);
        return Promise.reject(data);
      }
      message.error(data.tip || '请求失败');
    }
    return Promise.reject(data);
  },
  (error) => {
    // progress 进度条 -- 关闭
    if (NProgress.isStarted()) {
      NProgress.done();
    }
    if (error.response?.status === 401) {
      handleUnauthorized();
      return Promise.reject(error);
    }
    if (error.response && isAxiosResponse(error.response)) {
      return Promise.reject({
        message: error.response.statusText,
        code: error.response.status,
        data: error.response.data,
      });
    }
    return Promise.reject(error);
  }
);

export default http;
